import React from "react";
import { MdSend } from "react-icons/md";
import { BsFillCameraFill, BsFillPersonCheckFill } from "react-icons/bs";
import profile from "../assets/profile.svg";
import { useSelector } from "react-redux";
import Popup from "reactjs-popup";
import MyConnections from "./MyConnections";
import { useRef } from "react";
import { usePost } from "../context/PostContext";
import PostMediaPreview from "./PostMediaPreview";
import Spinner from "./Loader/Spinner";

const FeedThought = () => {
  const { profile: userProfile } = useSelector((state) => state.authStore);
  const { setUploadMedia, done, createwithoutmedia, values, createpost, uploadMedia, loader, setValues, taggedConnections } = usePost();

  const mediaRef = useRef();

  async function handleSubmit() {
    if(!done){
      if (uploadMedia && uploadMedia.length > 0){
        await createpost(false);
      } else if (!uploadMedia && values.text){
        await createwithoutmedia();
      }
    }
    return;
  }
  
  return (
    <div className="bg-[#eef0f4] p-3 rounded-xl">
      <div className="flex items-center pb-4">
        <div className="ml-2 mr-4 flex items-center cursor-pointer self-start justify-between">
          <img
            src={
              userProfile?.profilePicture ? userProfile.profilePicture : profile
            }
            alt=""
            className="h-[3rem] w-[3rem] bg-jumbleng-primary-light object-cover rounded-full"
          />
        </div>
        <textarea
          rows="2"
          cols="50"
          onChange={(e) => setValues({text: e.target.value})}
          className="w-full bg-transparent border-none focus:outline-none placeholder-black placeholder:font-medium placeholder:text-base  resize-none"
          placeholder="Share your thoughts..."
        />
      </div>
      <PostMediaPreview />
      {taggedConnections.length > 0 && <p className="my-3 truncate px-3 text-xs font-semibold">
        <span>Tagged:</span> {taggedConnections.map(user => {
          return (taggedConnections.indexOf(user) <= 4 && <span key={user?.userId}> {user?.firstName} {user?.lastName}{taggedConnections.indexOf(user) < 4 && ', '}</span> )
        })}
      </p>}
      <div className="ml-2 flex items-center justify-between">
        <div className="flex items-center">
          <label htmlFor="mediaUpload">
            <div className="flex items-center bg-white py-2 px-3 rounded-full cursor-pointer mr-5">
              <div className="bg-[#ebeded] p-2 rounded-full">
                <BsFillCameraFill className="text-xl" />
              </div>
              <p className="font-semibold pl-3">Photo/video</p>
              <input multiple ref={mediaRef} type="file" name="mediaUpload" className="hidden" onChange={(event) => {
                setUploadMedia(event.target.files);
              }} id="mediaUpload" accept="image/*, video/*" />
            </div>
          </label>
          <Popup
            trigger={
              <div className="flex items-center bg-white py-2 px-3 rounded-full cursor-pointer ">
                <div className="bg-[#ebeded] p-2 rounded-full">
                  <BsFillPersonCheckFill className="text-xl" />
                </div>
                <p className="font-semibold pl-3">Tag</p>
              </div>
            }
            position="right center"
            modal
            closeOnDocumentClick={false}
            nested
            contentStyle={{
              borderRadius: "12px",
              backgroundColor: "white",
              width: "fit-content",
              fontSize: "0.8rem",
              maxHeight: "98%",
              overflow: "auto",
            }}
          >
            {(close) => <MyConnections close={close} />}
          </Popup>
        </div>
        <div onClick={handleSubmit} className="flex items-center bg-black text-white p-3 rounded-full cursor-pointer mr-2">
          <p className="font-semibold pr-3">Posts</p>
          {loader ? <Spinner /> : <MdSend className="text-xl" />}
        </div>
      </div>
    </div>
  );
};

export default FeedThought;
